

  <div *ngIf="!isShowResult">
    <h2 mat-dialog-title mat-dialog-draggable-title>{{'title.assign_user_department' | translate}}
      <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickBtnCancel()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <mat-divider></mat-divider>
    <form #f="ngForm" (ngSubmit)=" f.form.valid && onCreateGroup()"
      appFocusFirstElement style="margin-top: 10px;">
      <mat-dialog-content>
            <div class="row">

                <div class="col-sm-12" style="padding-right: 2rem !important;margin-bottom: 15px;">
                  <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
                    <span class="ant-upload pb-2" style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'search_form.department_user' | translate}}</span>
                  </mat-panel-title>
                  <div>
                    <nz-input-group [nzSuffix]="suffixUserInput">
                      <input nz-input [(ngModel)]="inputUserValue"
                             (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="{{'search_form.department_search_placeholder' | translate}}" id="inputUser" maxlength="200"/>
                      <nz-autocomplete #autoUserSearching>
                        <nz-auto-option *ngFor="let user of filteredUserOptions"
                                        (selectionChange)="autocompleteUserSelected($event, user)"
                                        [nzValue]="''">{{user.fullName}} - {{user.email}}</nz-auto-option>
                      </nz-autocomplete>
                    </nz-input-group>
                    <ng-template #suffixUserInput>
                      <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                    </ng-template>
                    <ng-template #indicatorUserInput>
                      <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
                    </ng-template>
                  </div>
                  <nz-table nzBordered [nzNoResult]="null" [nzData]="listUserInDepartment" nzShowPagination=false
                            class="mt-2 ant-table-no-border border-top-0" [ngClass]="{'is-data': listUserInDepartment.length > 0}">
                    <tbody>
                    <tr *ngFor="let username of listUserInDepartment" class="editable-row">
                      <td>{{username.fullName}} - {{username.email}}</td>
                      <td class="text-center">
                        <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                           (nzOnConfirm)="deleteCertificate(username)" [nzIcon]="iconDel"
                           nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                        </a>
                        <ng-template #iconDel>
                          <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                        </ng-template>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </div>
            </div>
      </mat-dialog-content>
      <mat-divider></mat-divider>

      <!-- Huỷ bỏ & Lưu -->
      <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button [disabled]="!isFormChanging && !change || (listUserInDepartment.length == 0)" type="submit" cdkFocusInitial color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'button.save' | translate}}
        </button>
      </mat-dialog-actions>
    </form>
  </div>

  <div *ngIf="isShowResult">
    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'department_manage.dialog_add_user.title' | translate}}
      <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content>
      <div class="row pt-3 pb-3">
        <div class="col-12">
            <p>{{'department_manage.dialog_add_user.success' | translate}} <span style="font-weight: bold;">{{countSuccess}}</span></p>
            <p>{{'department_manage.dialog_add_user.failed' | translate}} <span style="font-weight: bold;">{{countError}}</span></p>
        </div>

          <div class="col-12" *ngIf="listErrorUser.length > 0">
            <div class="mat-table-container">
                <mat-table [dataSource]="listErrorUser" class="mat-table-col-extra-sm">
                    <!-- Full name -->
                    <ng-container matColumnDef="fullName">
                        <mat-header-cell *matHeaderCellDef style="width: 50%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                            {{'headertable.name' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 50%;">
                            <span matTooltip="{{element.fullName}}" class="fix-width" style="margin-left: -5px;">
              {{element.fullName}}
            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Lỗi -->
                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef style="max-width: 50%;" class="mat-header-cell-center">
                            {{'headertable.error' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{'alert.add_user_department_error_notify' | translate}}" class="" style="max-width: 50%;">
                            <span class="fix-width">{{'alert.add_user_department_error_notify' | translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumnsResult; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsResult;" matRipple class="element-row" [cdkDetailRow]="row">
                    </mat-row>
                </mat-table>
            </div>
        </div>

      </div>
    </mat-dialog-content>
    <div>
      <mat-divider></mat-divider>
      <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="closeDialog()" type="button" style="margin-bottom: 0px !important;">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
        </mat-dialog-actions>
    </div>
</div>
